export enum StageStatus {
  Passed = 'PASSED',
  Current = 'CURRENT',
  Future = 'FUTURE',
  Viewed = 'VIEWED',
}

export enum BpfCloseReasonType {
  Lost = 'LOST',
  Won = 'WON',
}

export type StagesViewType = 'all' | 'active';

export type BPFAPINameSpase<Response> = { bpf: Response };
